@import '~style-sheet-helpers/core.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';

.menu-toggler {
  width: 100%;
  background-color: @insights-page--report-dropdown--background-color;
  height: 32px;
  border-radius: 4px;
  border: 1px solid @insights-page--report-dropdown--border-color;
  display: flex;
  justify-content: flex-end;
  &:active,
  &:hover {
    background-color: @insights-page--report-dropdown--hover--background-color;
    border-top: 1px solid @insights-page--report-dropdown--hover--border-color;
  }
}
